import { DEF_SEARCH_PARAM_FE } from '../components/Fleet-Efficiency/constants';

const defaultState = {
  searchParams: {
    ...DEF_SEARCH_PARAM_FE,
  },
  filter: {
    filterBy: 'Fleet',
    selVehIds: [],
  },
  disableDownloadBtns: true,
  defaultVehIds: [],
};

function fleetEfficiencyReducer(state = defaultState, action) {
  switch (action.type) {
    case 'API_FLTR_FE':
      return {
        ...state,
        searchParams: action.payload,
      };
    case 'UPD_API_FLTR_FE':
      return {
        ...state,
        defaultVehIds: action.payload.defaultVehIds,
        searchParams: {
          ...state.searchParams,
          vehicleIds: action.payload.vehicleIds,
        },
      };
    case 'FLTR_UI_STATE_FE':
      return {
        ...state,
        filter: action.payload,
      };
    case 'FE_TOGGLE_DWNLD_BTN':
      return { ...state, disableDownloadBtns: action.payload };
    default:
      return state;
  }
}

export default fleetEfficiencyReducer;
